import React from 'react';
import styles from './Devices.module.scss';

interface BatteryIndicatorProps {
  battery: number | null;
}

/** Matches rescue-landing getBatteryIcon(): █ = filled, ░ = empty */
function getBatteryIcon(pct: number): string {
  if (pct > 75) {
    return '\u2588\u2588\u2588\u2588';
  }
  if (pct > 50) {
    return '\u2588\u2588\u2588\u2591';
  }
  if (pct > 25) {
    return '\u2588\u2588\u2591\u2591';
  }
  if (pct > 0) {
    return '\u2588\u2591\u2591\u2591';
  }
  return '\u2591\u2591\u2591\u2591';
}

export default function BatteryIndicator({ battery }: BatteryIndicatorProps) {
  if (battery === null) {
    return <span className={styles.textMuted}>{'\u2014'}</span>;
  }

  let colorClass: string;
  if (battery > 50) {
    colorClass = styles.batteryOk;
  } else if (battery > 20) {
    colorClass = styles.batteryMid;
  } else {
    colorClass = styles.batteryLow;
  }

  return (
    <div className={colorClass}>
      <div>{getBatteryIcon(battery)}</div>
      <div className={styles.batteryPct}>{battery}%</div>
    </div>
  );
}
